// features/contact/contact.slice.ts
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { submitContactFormApi, ContactFormPayload } from './contact.service';

export const submitContactForm = createAsyncThunk(
  'contact/submitContactForm',
  async (payload: ContactFormPayload) => {
    const data = await submitContactFormApi(payload);
    return data;
  }
);

type Awaited<T> = T extends Promise<infer U> ? U : T;

type ContactState = {
  message: string | null;
  contactData: Awaited<ReturnType<typeof submitContactFormApi>> | null;
  loading: boolean;
  error: string | null;
};

const initialState: ContactState = {
  message: null,
  contactData: null,
  loading: false,
  error: null,
};

const contactSlice = createSlice({
  name: 'contact',
  initialState,
  reducers: {
    clearContactData: (state) => {
      state.contactData = null;
      state.error = null;
      state.message = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(submitContactForm.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(submitContactForm.fulfilled, (state, action) => {
        state.loading = false;
        state.contactData = action.payload;
        state.message = 'Contact form submitted successfully!';
      })
      .addCase(submitContactForm.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to submit contact form';
      });
  },
});

export const { clearContactData } = contactSlice.actions;
export default contactSlice.reducer;
